<template>
    <!-- 受益人資料區塊 -->
    <div :id="'beneficiary' + user_id" @change="saveBeneficiaryData">
        <div class="inline">
            <div class="inputControl">
                <div class="inputTitle" :class="{ 'pinkText': check1 }">受益人{{ beneficiary_id }}姓名</div>
                <input type="text" class="inputStyle tlf_r_f1 clarity-mask" :id="'beneficiaryName'+user_id" value="" v-model="beneficiaryData.beneficiaryName"
                    :class="{ 'alert': check1 }">
                <p class="alertStr"></p>
            </div>
            <div class="inputControl">
                <div class="inputTitle" :class="{ 'pinkText': check2 }">身分證/居留證</div>
                <input type="text" class="inputStyle tlf_n_l5 clarity-mask" :id="'beneficiaryIdNo'+user_id" value="" v-model="beneficiaryData.beneficiaryIdNo"
                    v-on:blur="checkIdType" :class="{ 'alert': check2 }" @keyup="upper">
                <p class="alertStr"></p>
            </div>
        </div>
        <BirthdayChange
            :dateTimeProps="beneficiaryData.beneficiaryBirthday"
            @getDateTime="getBeneficiaryBirthday"
            :nickName="'insure' + user_id + 'beneficiary' + beneficiary_id"
            :key="reloadYearChangeKey"
            ref="yearRef"
        />
        <div class="inline">
            <div class="inputControl">
                <div class="inputTitle" :class="{ 'pinkText': check3 }">國籍</div>
                <model-select :options="nationOptions"
                              class="inputStyle arrow selectSearch clarity-mask"
                              :class="{ 'alert': check3 }"
                              v-model="beneficiaryDataRiskCountry"
                              placeholder="請選擇國籍"
                >
                </model-select>
                <p class="alertStr"></p>
            </div>
            <div class="inputControl">
                <div class="inputTitle" :class="{ 'pinkText': check4 }">受益人手機號碼
                    <div class="formBtn right" @click="sameMobile">
                        同要保人手機
                    </div>
                </div>
                <input type="text" class="inputStyle tlf_n_l4 clarity-mask" :id="'beneficiaryTel'+user_id" value="" v-model="beneficiaryData.beneficiaryMob"
                    :class="{ 'alert': check4 }" @keyup="upper">
                <p class="alertStr"></p>
            </div>
        </div>
        <div class="oneline addressTitle">
            <div class="inputTitle" :class="{ 'pinkText': check5 && check6 && check7 }">受益人通訊地址</div>
            <div class="inputTitle formBtn right" @click="sameAddress">同要保人地址</div>
        </div>
        <div class="inline">
            <div class="inputControl">
                <select name="" id="" class="inputStyle arrow clarity-mask" v-model="beneficiaryData.beneficiaryAddrCity"
                    @change="getAddrZipList(null)" :class="{ 'alert': check5 }">
                    <option value="" selected disabled>縣市</option>
                    <option v-for="(city, index) in cityList" :value="city.id" :key="index">{{ city.cityName }}</option>
                </select>
                <p class="alertStr"></p>
            </div>
            <div class="inputControl">
                <select class="inputStyle arrow clarity-mask" v-model="beneficiaryData.beneficiaryAddrZip" :class="{ 'alert': check6 }">
                    <option value="" selected disabled>區域</option>
                    <option v-for="(zip, index) in zipList" :value="zip.id" :key="index">{{ zip.zipName }}</option>
                </select>
                <p class="alertStr"></p>
            </div>
        </div>
        <div class="oneline">
            <div class="inputControl">
                <input type="text" name="" class="inputStyle tlf_r_f6 clarity-mask" :id="'beneficiaryAddress'+user_id" v-model="beneficiaryData.beneficiaryAddrs"
                    :class="{ 'alert': check7 }">
                <p class="alertStr"></p>
            </div>
        </div>
        <div class="oneline">
            <div class="inputTitle" :class="{ 'pinkText': check8 }">受益人是被保險人的誰(關係)：<span class="clarity-unmask">{{showBeneficiaryRelation()}}</span></div>
            <select id="beneficiaryRelation" class="inputStyle arrow clarity-unmask" name="beneficiaryRelation1"
                v-model="beneficiaryData.beneficiaryRelation" :class="{ 'alert': check8 }">
                <option value="" selected disabled>請選擇關係</option>
                <option value="SPOUSE" v-if="insureType <= 2|| insureType === 5" >配偶</option>
                <option value="SIBLING" v-if="(policyType === 'APPLY' && (insureType <= 2 || insureType === 5 )) && policyTypeSwitch === 'A'">兄弟姐妹(選此,需簽回要保書)</option>
                <option value="GRANDPARENT" v-if="insureType <= 2 || insureType === 5">祖父母</option>
                <option value="PARENT">父母</option>
                <option value="CHILD" v-if="insureType <= 2 || insureType === 5">子女</option>
                <option value="GRANDCHILD" v-if="insureType <= 2 || insureType === 5">孫子女</option>
            </select>
            <p class="alertStr"></p>
        </div>
        <div class="oneline" v-if="beneficiaryData.beneficiaryRelation ==='SIBLING'">
            <div class="inputTitle" :class="{ 'pinkText': check9 }">受益人為兄弟姊妹的原因<a @click="popupBeneficiaryRelation()" class="popupBeneficiaryIcon"><img src="../../assets/question.svg" alt=""></a></div>
            <select class="inputStyle arrow clarity-unmask" v-model="beneficiaryData.beneficiaryNotes" :class="{ 'alert': check9 }">
                <option value="" selected disabled>請選擇</option>
                <option value="單身且父母年邁由兄弟姊妹照顧" >單身且父母年邁由兄弟姊妹照顧</option>
                <option value="單身且父母已離世" >單身且父母已離世</option>
                <option value="家庭成員共同出遊" >家庭成員共同出遊</option>
                <option value="子女由兄弟姊妹照顧">子女由兄弟姊妹照顧</option>
                <option value="須分擔照顧兄弟姊妹的責任" >須分擔照顧兄弟姊妹的責任</option>
            </select>
            <p class="alertStr"></p>
        </div>
    </div>
</template>
<script setup>
        import BirthdayChange from "@/components/birthdayChange.vue";
        import LoadData from "@/utils/loadData";
        import CheckData from "@/utils/checkData";
        import _ from "lodash";
        import {ModelSelect}  from 'vue-search-select'
        import {onMounted, ref, watch} from "vue";
        import Swal from "sweetalert2";

        const props = defineProps({
            user_id: Number,
            beneficiary_id: Number,
            beneficiaryCheck:Boolean,
            insureType: Number,
            applicantData: Object
        })


        let riskCountryList = {};//國籍清單
        let pageStorage = {};

        const nationOptions = ref([]);//國籍清單(顯示用)
        const cityList = ref([]);//城市清單
        const zipList = ref([]);//區域清單
        const reloadYearChangeKey = ref(0);//觸發 yearChange 重新載入
        const idType = ref(true);//true:台灣人,false:外國人
        const beneficiaryDataRiskCountry = ref("");
        const policyType = ref("");
        const beneficiaryData = ref({
            beneficiaryIdNo: '',
            beneficiaryName: '',
            beneficiaryBirthday: {},
            beneficiaryRiskCountry: '',
            beneficiaryMob: '',
            beneficiaryAddrCity: '',
            beneficiaryAddrZip: '',
            beneficiaryAddrs: '',
            beneficiaryRelation: '',
            beneficiaryNotes: ''
        });
        const check1 = ref(false);
        const check2 = ref(false);
        const check3 = ref(false);
        const check4 = ref(false);
        const check5 = ref(false);
        const check6 = ref(false);
        const check7 = ref(false);
        const check8 = ref(false);
        const check9 = ref(false);
        const policyTypeSwitch = ref('');
        const yearRef = ref();

        //載入國籍清單
        const getRiskCountryList = () => {
            LoadData.getRiskCountryList(function (data) {
                riskCountryList = data;
                if(beneficiaryData.value.beneficiaryIdNo.length > 0){
                    checkIdType();
                }
            });
        }
        //載入縣市清單
        const getAddrCityList = () => {
            LoadData.getAddrCityList(function (data) {
                cityList.value = data;
            });
        }
        //載入區域清單
        const getAddrZipList = (setZip) => {
            if(beneficiaryData.value.beneficiaryAddrCity){
                var cityObject = cityList.value.find(city => city.id === beneficiaryData.value.beneficiaryAddrCity)
                LoadData.getAddrZipList(cityObject.cityCode, function (data) {
                    zipList.value = data;
                    beneficiaryData.value.beneficiaryAddrZip = setZip || "";
                    saveBeneficiaryData();
                });
            }
        }
        //檢查ID類型
        const checkIdType = () => {
            var checkIdType = CheckData.id(beneficiaryData.value.beneficiaryIdNo);
            if (checkIdType === 'resident') {
                idType.value = false;
                if (beneficiaryDataRiskCountry.value === "台灣(Taiwan)") {
                    beneficiaryDataRiskCountry.value = "";
                }

                if(nationOptions.value.length !== riskCountryList.length){
                    nationOptions.value = [];
                    riskCountryList.forEach(rc => {
                        nationOptions.value.push({
                            value: rc.riskCountryName,
                            text: rc.riskCountryName
                        });
                    });
                }
            } else {
                idType.value = true;
                nationOptions.value = [];
                nationOptions.value.push({
                    value: "台灣(Taiwan)",
                    text: "台灣(Taiwan)"
                });
                beneficiaryDataRiskCountry.value = "台灣(Taiwan)";
            }
            saveBeneficiaryData();
        }
        //取得受益人生日
        const getBeneficiaryBirthday = (data) => {
            beneficiaryData.value.beneficiaryBirthday = data;
        }
        //同要保人地址
        const sameAddress = () =>{
            beneficiaryData.value.beneficiaryAddrCity = props.applicantData.applicantAddrCity;
            getAddrZipList(props.applicantData.applicantAddrZip);//需要先更新區域清單
            beneficiaryData.value.beneficiaryAddrs = props.applicantData.applicantAddrs;
            saveBeneficiaryData();
        }
        //同要保人手機
        const sameMobile = () =>{
            beneficiaryData.value.beneficiaryMob = props.applicantData.applicantMob;
            saveBeneficiaryData();
        }
        //顯示選擇的被保人關係
        const showBeneficiaryRelation = () =>{
            switch (beneficiaryData.value.beneficiaryRelation){
                case "SPOUSE":
                    return "配偶"
                case "SIBLING":
                    return "兄弟姊妹(選此,需簽回要保書)"
                case "GRANDPARENT":
                    return "祖父母"
                case "PARENT":
                    return "父母"
                case "CHILD":
                    return "子女"
                case "GRANDCHILD":
                    return "孫子女"
                default :
                    return "";
            }
        }
        //更動資料儲存至 sessionStorage
        const saveBeneficiaryData = () => {
            const detailStorage = JSON.parse(sessionStorage.getItem("detailStorage"));
            detailStorage.insureData[props.user_id].beneficiaryArray[props.beneficiary_id - 1] = beneficiaryData.value;
            sessionStorage.setItem("detailStorage", JSON.stringify(detailStorage));
            if(props.beneficiaryCheck === true){
                checkForm();
            }
        }
        //檢核受益人資料
        const checkForm = () => {
            //姓名檢核
            if (beneficiaryData.value.beneficiaryName === "") {
                check1.value = true;
            } else {
                check1.value = false;
            }
            if (!CheckData.name(beneficiaryData.value.beneficiaryName)) {
                check1.value = true;
            }else{
                check1.value = false;
            }
            //身分證檢核
            if (!CheckData.id(beneficiaryData.value.beneficiaryIdNo)) {
                check2.value = true;
            } else {
                check2.value = false;
            }
            //國籍檢核
            if (beneficiaryData.value.beneficiaryRiskCountry === "" || beneficiaryData.value.beneficiaryRiskCountry == null) {
                check3.value = true;
            } else {
                check3.value = false;
            }
            //手機檢核
            if (!CheckData.mobile(beneficiaryData.value.beneficiaryMob)) {
                check4.value = true;
            } else {
                check4.value = false;
            }
            //地址檢核
            if (beneficiaryData.value.beneficiaryAddrCity === ""
                || beneficiaryData.value.beneficiaryAddrZip === ""
                || beneficiaryData.value.beneficiaryAddrs === ""
                || !CheckData.address(beneficiaryData.value.beneficiaryAddrs)) {
                check5.value = true;
                check6.value = true;
                check7.value = true;
            } else {
                check5.value = false;
                check6.value = false;
                check7.value = false;
            }
            //與被保人關係
            if (beneficiaryData.value.beneficiaryRelation === "") {
                check8.value = true;
            } else {
                check8.value = false;
            }
            if(beneficiaryData.value.beneficiaryRelation ==='SIBLING') {
                //受益人為兄弟姊妹的原因
                if (beneficiaryData.value.beneficiaryNotes === "" || beneficiaryData.value.beneficiaryNotes == null) {
                    check9.value = true;
                } else {
                    check9.value = false;
                }
            }

            //觸發 yearChange checkForm();
            yearRef.value?.checkForm(true);
        }
//兄弟姊妹談窗
        const popupBeneficiaryRelation = ()=>{
            const alertCon =
                '<div class="noticeCon">' +
                '<ul class="caption">' +
                '<li class="captionTitle">單身且父母年邁由兄弟姊妹照顧</li>' +
                '<li>目前為單身未婚者，主要由兄弟姐妹協助照顧年邁的父母，兄弟姊妹在家庭中扮演重要角色，因此希望透過保險安排保障其未來。</li>' +
                '</ul>' +
                '<ul class="caption">' +
                '<li class="captionTitle">單身且父母已離世</li>' +
                '<li>目前單身未婚且父母皆已離世，兄弟姊妹為您最親近的家人，因此選擇其作為保險受益人，以落實個人風險規劃。</li>' +
                '</ul>' +
                '<ul class="caption">' +
                '<li class="captionTitle">家庭成員共同出遊</li>' +
                '<li>此次旅程由您與直系家人共同出遊。為預作完善的風險規劃，若在旅途中發生意外導致無法承接保險利益，希望由兄弟姊妹作為受益人，協助處理相關事宜並延續家庭照顧安排。</li>' +
                '</ul>' +
                '<ul class="caption">' +
                '<li class="captionTitle">子女由兄弟姊妹照顧</li>' +
                '<li>目前由兄弟姊妹協助扶養您的子女，因此希望透過保險利益支持其照顧責任，確保子女生活穩定。</li>' +
                '</ul>' +
                '<ul class="caption">' +
                '<li class="captionTitle">須分擔照顧兄弟姊妹的責任</li>' +
                '<li>您的兄弟姊妹可能因健康、經濟或家庭因素需要您協助照顧，因此您希望保險利益能作為其生活支持的一部份。</li>' +
                '</ul>' +
                '</div>'
            Swal.fire({
                title: "受益人若指定為兄弟姊妹",
                showConfirmButton: false,
                showCloseButton: true,
                customClass: {
                    container: "popupBeneficiary",
                },
                html: alertCon
            });
        }

        //身分證只能大寫
        const upper = _.debounce(()=>{
            if(beneficiaryData.value.beneficiaryIdNo !== ""){
                beneficiaryData.value.beneficiaryIdNo = beneficiaryData.value.beneficiaryIdNo.toString().toUpperCase();
                beneficiaryData.value.beneficiaryIdNo = CheckData.convertToHalfWidth(beneficiaryData.value.beneficiaryIdNo);
            }
            if(beneficiaryData.value.beneficiaryMob !== ""){
                beneficiaryData.value.beneficiaryMob = CheckData.convertToHalfWidth(beneficiaryData.value.beneficiaryMob);
            }
        },50)
        //載入detailStorage
        const loadDetailStorage = () =>{
            const detailStorage = JSON.parse(sessionStorage.getItem("detailStorage"));
            if (detailStorage.insureData[props.user_id] != null && JSON.stringify(detailStorage.insureData[props.user_id]) !== '{}') {
                if (detailStorage.insureData[props.user_id].beneficiaryArray[props.beneficiary_id - 1] != null
                 && JSON.stringify(detailStorage.insureData[props.user_id].beneficiaryArray[props.beneficiary_id - 1]) !== '{}') {
                    beneficiaryData.value = detailStorage.insureData[props.user_id].beneficiaryArray[props.beneficiary_id - 1];
                    if (beneficiaryData.value.beneficiaryIdNo !== '') {
                        checkIdType();
                    }
                    if (beneficiaryData.value.beneficiaryAddrCity !== '') {
                        getAddrZipList(beneficiaryData.value.beneficiaryAddrZip);
                    }
                    beneficiaryDataRiskCountry.value = beneficiaryData.value.beneficiaryRiskCountry;
                    reloadYearChangeKey.value += 1;
                }
            }
        }
        //載入pageStorage
        const loadPageStorage = ()=>{
            pageStorage = JSON.parse(sessionStorage.getItem("pageStorage"));
            policyType.value = pageStorage.policyType;
            policyTypeSwitch.value = pageStorage.getPolicyTypeSwitch;
        }

        getRiskCountryList();
        getAddrCityList();
        defineExpose({ checkForm  }) //父組件需使用
        onMounted(()=>{
            loadPageStorage();
            loadDetailStorage();
        });
        //監控beneficiaryDataRiskCountry
        watch(()=>beneficiaryDataRiskCountry.value, (value)=>{
            beneficiaryData.value.beneficiaryRiskCountry = value;
            saveBeneficiaryData();
        })

</script>

<style lang="scss">
.popupBeneficiaryIcon img{
    cursor: pointer;
    width: 18px;
    height: 18px;
    vertical-align: middle;
    padding-left: 5px;
}
.popupBeneficiary {
    &.swal2-container {
        text-align: left;
        overflow-y: hidden !important;

        .swal2-popup {
            width: 42em;
            max-width: inherit;
            @media screen and (max-width: $padLandscape) {
                width: 95%;
            }
            @media screen and (max-width: $small) {
                width: 100%;
                height: 100%;
            }
        }

        .swal2-html-container {
            margin:1em;
            padding: 0;
            overflow-y:auto;
            @media screen and (max-width: $padLandscape) {
                margin: 3%;
            }
            @media screen and (max-width: $small) {
                margin: 10px !important;
            }
        }

        .swal2-title {
            padding: 0.8em 0 !important;
        }
    }

    .noticeCon {
        max-height: calc(80vh - 60px);
        padding: 0 20px;
        box-sizing: border-box;
        font-family: 'Noto Sans TC', '微軟正黑體', sans-serif;
        .title2{font-size:18px;}
        div:where(.swal2-container) div:where(.swal2-popup){
            padding:0;
        }

        @media screen and (max-width: $small) {
            padding: 10px;
            font-size: 16px;
        }


        ul {
            list-style-type: decimal;
            list-style-position: outside;
            line-height: 40px;
            padding: 0 20px 0;
            box-sizing: border-box;
            margin: 0 0 20px;
            text-align: left;
            &.caption{padding:0 !important;}
            @media screen and (max-width: $pad) {
                line-height: 30px;
            }


            .blue {
                color: $blue-700;
                font-weight: 700;
            }
        }
    }
    .caption{
        border:1px solid $blue-700;
        font-size:16px;
        border-radius: 20px;
        overflow:hidden;
        li{
            padding: 10px 15px;
            line-height: 24px;
            display:flex;
            align-items: center;
            border-bottom:1px solid $gray-400;
            justify-content: center;
            &:last-of-type{border:0}
            &.captionTitle{
                background: $blue-700;
                justify-content: center;
                color:#fff;
            }
            p{
                width:50%;
                margin:5px 0;
                box-sizing: border-box;
                padding:0 10px;
                text-align:center;
            }
        }

    }
}
</style>
